import { Box } from "@mui/material";
import {
  PaymentIcon,
  type PaymentType,
} from "react-svg-credit-card-payment-icons";

interface PaymentMethodIconProps {
  type: string;
}

const TYPE_MAP: Record<string, PaymentType> = {
  paypal: "Paypal",
  paypalec: "Paypal",
  visa: "Visa",
  mastercard: "Mastercard",
  amex: "Amex",
  americanexpress: "Amex",
  discover: "Discover",
};

const getIconType = (type: string): PaymentType => {
  const key = type.toLowerCase();
  if (TYPE_MAP[key]) return TYPE_MAP[key];
  return "Generic";
};

const ICON_SIZE = 40;

const PaymentMethodIcon = ({ type }: PaymentMethodIconProps) => {
  const iconType = getIconType(type);

  return (
    <Box className="shrink-0">
      <PaymentIcon
        type={iconType}
        format="flatRounded"
        width={ICON_SIZE}
        height={ICON_SIZE}
      />
    </Box>
  );
};

export default PaymentMethodIcon;
